import React from "react";
import { Link } from "react-router-dom";
import Frame304 from "../Frame304";
import "./Menu.css";

function Menu(props) {
  const {
    overlapGroup,
    line79,
    place,
    line80,
    aboutUs,
    line81,
    services,
    line82,
    mediaPublications,
    line83,
    gallery,
    line84,
    blog,
    line85,
    contactUs,
    line86,
    frame304Props,
  } = props;

  return (
    <div className="menu screen">
      <Link to="/home">
        <div className="group-308">
          <div className="overlap-group" style={{ backgroundImage: `url(${overlapGroup})` }}>
            <img className="line-79" src={line79} />
          </div>
        </div>
      </Link>
      <Link to="/home">
        <div className="group-309">
          <div className="place poppins-medium-tundora-18px">{place}</div>
          <img className="line-8" src={line80} />
        </div>
      </Link>
      <Link to="/about">
        <div className="group-31">
          <div className="about-us poppins-medium-tundora-18px">{aboutUs}</div>
          <img className="line-8" src={line81} />
        </div>
      </Link>
      <Link to="/services">
        <div className="group-31">
          <div className="services poppins-medium-tundora-18px">{services}</div>
          <img className="line-8" src={line82} />
        </div>
      </Link>
      <Link to="/media-publications">
        <div className="group-31">
          <div className="media-publications poppins-medium-tundora-18px">{mediaPublications}</div>
          <img className="line-8" src={line83} />
        </div>
      </Link>
      <Link to="/gallery">
        <div className="group-313">
          <div className="gallery poppins-medium-tundora-18px">{gallery}</div>
          <img className="line-8-1" src={line84} />
        </div>
      </Link>
      <div className="group-314">
        <div className="blog poppins-medium-tundora-18px">{blog}</div>
        <img className="line-8-1" src={line85} />
      </div>
      <Link to="/contact-us">
        <div className="group-315">
          <div className="contact-us poppins-medium-tundora-18px">{contactUs}</div>
          <img className="line-86" src={line86} />
        </div>
      </Link>
      <Frame304 frame302Props={frame304Props.frame302Props} />
    </div>
  );
}

export default Menu;
